//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "clinical_manifestations_scoring_criteria_for_vulvovaginal_candidiasis",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "无" },
        { value: "1", name: "偶有发作" },
        { value: "2", name: "症状明显" },
        { value: "3", name: "持续发作，坐立不安" },
      ],
      dataList1: [
        { value: "0", name: "无" },
        { value: "1", name: "轻" },
        { value: "2", name: "中" },
        { value: "3", name: "重" },
      ],
      dataList2: [
        { value: "0", name: "无" },
        { value: "1", name: "<1/3阴道壁充血" },
        { value: "2", name: "1/3~2/3阴道壁充血" },
        { value: "3", name: ">2/3阴道壁充血" },
      ],
      dataList3: [
        { value: "0", name: "无" },
        { value: "3", name: "有" },
      ],
      dataList4: [
        { value: "0", name: "无" },
        { value: "1", name: "较正常稍多" },
        { value: "2", name: "量多、无溢出" },
        { value: "3", name: "量多、有溢出" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/clinical_manifestations_scoring_criteria_for_vulvovaginal_candidiasis.vue